import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import apiRequestType from "../../apiRequestType";

const getUserGroupsManadatedShotclasses = (
  classtype,
  pageNum,
  pageSize,
  usergroupid
) => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.ADMIN.GROUP_MANAGEMENT.GET_USER_GROUPS_MANDATED_SHOTCLASSES(
      classtype,
      pageNum,
      pageSize,
      usergroupid
    )
  );
};

export default getUserGroupsManadatedShotclasses;
